import { Injectable } from "@angular/core";
import { ApiService } from "..";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GroupedEntityToSave, GroupedEntityFilter, GroupedEntity } from "../..";

@Injectable(
    {providedIn: "root"}
)
export class GroupedEntityService {
    constructor(
        public apiService: ApiService,
      ) {
      }
    
      saveOrUpdateGroupedEntity(body: GroupedEntityToSave): Observable<any> {
        return this.apiService.post(`${this.apiService.businessEntity}/entity/groups`, body)
          .pipe(map(item => item));
      }
    
      findGroupedEntityByFilters(request?: string): Observable<GroupedEntity[]> {
        return this.apiService.get(`${this.apiService.businessEntity}/entity/groups?${request}`)
          .pipe(map(item => item));
      }
  
      changeStateOfEntityGroup(body: GroupedEntityToSave): Observable<any> {
        return this.apiService.put(`${this.apiService.businessEntity}/entity/groups`, body)
          .pipe(map(item => item));
      }
  
      findGroupNameByEntityCode(entityCode: string, groupNameList: GroupedEntity[]): string {
        const groupName: GroupedEntity = groupNameList
          .find(groupName => groupName.entityCodesList.includes(entityCode));
        return groupName? groupName.groupName: "";
      }
}